// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from '@rails/ujs';
import './sentry';

Rails.start();

document.addEventListener('DOMContentLoaded', () => {
  $('body').css('opacity', '0');
  if ($('.quiz-view').find('img').length) {
    $('.quiz-view img').one('load', () => {
      $('body').animate({ opacity: '1' });
    }).each((index, element) => {
      if (element.complete) {
        $(element).trigger('load');
      }
    });
  } else {
    $('body').animate({ opacity: '1' });
  }
});

// require('bootstrap');
